<template>
  <div style>
    <v-card class style="border-radius:10px">
      <v-container class="pb-0">
        <v-row class>
          <v-col cols="4" class="py-0 text-center">
            <v-avatar :color="color" tile :size="86" class="icon-box hover-tile" style>
              <v-icon x-large dark>{{item.icon}}</v-icon>
            </v-avatar>
          </v-col>
          <v-col cols="8" class="py-0 text-right">
            <h5 class="font-weight-light">Template name</h5>
            <h4>{{item.name}}</h4>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions class="grey lighten-4">
        <v-spacer></v-spacer>
        <v-btn color="blue" :to="`/template/${item.id}`" dark>Preview</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["item"],
  computed: {
    color() {
      if (this.item.type === "Event") {
        return "green";
      }
      if (this.item.type === "Business") {
        return "black";
      }
      return "blue";
    }
  }
};
</script>

<style>
.icon-box {
  transform: translateY(-25px);
  border-radius: 10px;
}
.icon-box:hover {
  transform: translateY(-30px);
}
</style>